// Skyder med to håndtag for et flight-filter (se snippets/flight-filter.liquid).
// Skyderen står på trinene mellem de værdier, der findes i filteret, så et
// interval aldrig er tomt. Når den flyttes, krydses de skjulte filterværdier
// af, og input-eventet bobler op til facets-formularen, som så filtrerer.
if (!customElements.get('flight-range')) {
  customElements.define(
    'flight-range',
    class FlightRange extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.boxes = Array.from(this.querySelectorAll('input[type="checkbox"][data-num]'))
          .map((box) => ({ box, num: Number(box.dataset.num) }))
          .filter(({ num }) => Number.isFinite(num));
        this.steps = [...new Set(this.boxes.map(({ num }) => num))].sort((a, b) => a - b);
        this.low = this.querySelector('[data-lo]');
        this.high = this.querySelector('[data-hi]');
        this.output = this.querySelector('[data-output]');
        this.fill = this.querySelector('[data-fill]');

        const last = this.steps.length - 1;
        this.querySelector('[data-min]').textContent = this.format(this.steps[0]);
        this.querySelector('[data-max]').textContent = this.format(this.steps[last]);
        if (last < 1) {
          this.classList.add('flight-range--single');
          this.output.textContent = this.format(this.steps[0]);
          return;
        }

        [this.low, this.high].forEach((input) => {
          input.max = String(last);
        });
        const active = this.boxes.filter(({ box }) => box.checked).map(({ num }) => num);
        this.low.value = String(active.length ? this.steps.indexOf(Math.min(...active)) : 0);
        this.high.value = String(active.length ? this.steps.indexOf(Math.max(...active)) : last);

        this.low.addEventListener('input', () => this.update(this.low));
        this.high.addEventListener('input', () => this.update(this.high));
        this.render();
      }

      format(n) {
        return n === undefined ? '' : String(n);
      }

      update(moved) {
        let a = Number(this.low.value);
        let b = Number(this.high.value);
        if (a > b) {
          if (moved === this.low) this.low.value = String((a = b));
          else this.high.value = String((b = a));
        }
        const everything = a === 0 && b === this.steps.length - 1;
        const from = this.steps[a];
        const to = this.steps[b];
        this.boxes.forEach(({ box, num }) => {
          box.checked = !everything && num >= from && num <= to;
        });
        this.render();
      }

      render() {
        const last = this.steps.length - 1;
        const a = Number(this.low.value);
        const b = Number(this.high.value);
        this.fill.style.left = `${(a / last) * 100}%`;
        this.fill.style.right = `${100 - (b / last) * 100}%`;
        // Står begge håndtag i højre ende, skal det venstre kunne tages først.
        this.low.classList.toggle('flight-range__input--top', a === last);

        const from = this.format(this.steps[a]);
        const to = this.format(this.steps[b]);
        this.output.textContent = a === 0 && b === last ? 'Alle' : a === b ? from : `${from} til ${to}`;
        this.low.setAttribute('aria-valuetext', from);
        this.high.setAttribute('aria-valuetext', to);
      }
    }
  );
}
